<div class="form-group" #root>
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="input-timepicker-skip-toggle"
          id="input-timepicker-skip-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }

    @if (showLabel && question?.question_copy) {
      <label [innerHtml]="question?.question_copy" class="form-group__label"></label>
    }

    <div class="custom-timepicker" [class.is-open]="isOpen">
      <div class="input-wrap">
        <div class="input-wrap-prepend">
          <div class="input-wrap-icon">
            <svg class="icon">
              <use xlink:href="#time"></use>
            </svg>
          </div>
        </div>

        <input
          #input
          type="text"
          class="form-control"
          placeholder="Select"
          [attr.pattern]="inputPattern"
          autocomplete="off"
          [(ngModel)]="inputValue"
          name="input-timepicker-value"
          (focus)="openPicker()"
          (click)="openPicker()"
          (input)="onInput($event)"
          (blur)="onBlur()"
          (keydown.enter)="onEnter($event)"
          />

          <div class="input-wrap-append" role="button" tabindex="0" (click)="togglePicker()">
            <div class="input-wrap-icon">
              <svg class="icon">
                <use xlink:href="#chevron-up-small"></use>
              </svg>
            </div>
          </div>
        </div>

        <div #dropdown class="custom-timepicker__dropdown" [hidden]="!isOpen" [class.custom-timepicker__dropdown--drop-up]="isDropUp" (mousedown)="$event.preventDefault()">
          <div class="custom-timepicker__column">
            <div #hourScroll class="custom-timepicker__scroll">
              <ul class="custom-timepicker__list">
                @for (option of hours; track option) {
                  <li
                    class="custom-timepicker__option"
                    [attr.data-value]="option"
                    [class.custom-timepicker__option--selected]="hasValue && selectedHour === option"
                    [class.is-disabled]="isHourDisabled(option)"
                    (mousedown)="$event.preventDefault()"
                    (click)="onSelectHour(option)">
                    {{ option }}
                  </li>
                }
              </ul>
            </div>
          </div>

          <div class="custom-timepicker__column">
            <div #minuteScroll class="custom-timepicker__scroll">
              <ul class="custom-timepicker__list">
                @for (option of minutes; track option) {
                  <li
                    class="custom-timepicker__option"
                    [attr.data-value]="option"
                    [class.custom-timepicker__option--selected]="hasValue && selectedMinute === option"
                    [class.is-disabled]="isMinuteDisabled(option)"
                    (mousedown)="$event.preventDefault()"
                    (click)="onSelectMinute(option)">
                    {{ option }}
                  </li>
                }
              </ul>
            </div>
          </div>

          <div class="custom-timepicker__tray">
            <button type="button" class="button button--sm button--secondary" (click)="onCancel($event)">Cancel</button>
            <button type="button" class="button button--sm button--primary" [disabled]="disabledButton" (click)="onApply($event)">Apply</button>
          </div>
        </div>
      </div>
    </div>